export const pluginName = "flowbite-react-plugin";
